import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface DownloadInvoiceButtonProps {
  targetElementId: string;
  orderNumber: string;
  className?: string;
  children?: React.ReactNode;
}

const DownloadInvoiceButton: React.FC<DownloadInvoiceButtonProps> = ({ 
  targetElementId, 
  orderNumber, 
  className = "w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 mt-4",
  children = "تحميل الفاتورة PDF"
}) => {
  
  const downloadPDF = async () => {
    const targetElement = document.getElementById(targetElementId);
    if (!targetElement) {
      console.error('لم يتم العثور على العنصر المحدد:', targetElementId);
      alert('خطأ: لم يتم العثور على الفاتورة للتحميل');
      return;
    }

    try {
      // تحويل HTML إلى صورة باستخدام html2canvas
      const canvas = await html2canvas(targetElement, {
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        allowTaint: true,
        scale: 2,
        height: targetElement.scrollHeight,
        width: targetElement.scrollWidth,
      } as any);

      // إنشاء PDF جديد بحجم الإيصال الحراري
      const imgData = canvas.toDataURL('image/png', 1.0);
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [80, 120], // حجم الإيصال الحراري
      });

      // حساب الأبعاد
      const pdfWidth = 80;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      // إضافة الصورة للـ PDF
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

      // تحميل الملف مباشرة بدون فتح Print Preview
      pdf.save(`invoice-${orderNumber}.pdf`);
      
      console.log('تم تحميل الفاتورة بنجاح');
    } catch (error) {
      console.error('خطأ في تحميل الفاتورة:', error);
      alert('حدث خطأ أثناء تحميل الفاتورة. يرجى المحاولة مرة أخرى.');
    }
  };

  return (
    <button
      onClick={downloadPDF}
      className={className}
      type="button"
    >
      {children}
    </button>
  );
};

export default DownloadInvoiceButton;
